import { Aufnahmebogen } from './Aufnahmebogen';
import { IDs } from '../../../helpers/IDs';

export class AufnahmebogenWaerme extends Aufnahmebogen {

    private curEnergietraeger: string;
    protected dataIgnored: any = {};

    constructor(dataSheet: Array<any>, dataDb: any) {
        super(dataSheet, dataDb);

        if (dataSheet.length) {
            this.initData(IDs.ENT_ENERGIEDATEN_WAERME);
            this.setJahre();
            this.setData();
        }
    }

    public getData(): Array<any> {
        const data: any = this.data;

        Object.keys(data).forEach((entity: any) => {
            data[entity] = this.getDataValided(data[entity]);
            const compare: Array<any> = this.dataIgnored[entity].map((item: any) => `${item.jahr}-${item.energietraeger_tid}`);
            data[entity] = data[entity].filter((row: any) => compare.indexOf(`${row.jahr}-${row.energietraeger_tid}`) === -1);
        });

        return data;
    }

    protected getDataValided(data: Array<any>): Array<any> {
        return data.filter((row: any) =>
            row.kosten
            || row.verbrauch
        );
    }

    protected getEinheitTid(): string {
        return ((this.dataDb[IDs.ENT_ENERGIEDATEN_WAERME_EINHEITEN] || [])
            .find((einheit: any) => einheit.name === this.getEinheit()) || {}).tid || null;
    }

    protected getEnergietraegerTid(): string {
        return ((this.dataDb[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] || [])
            .find((einheit: any) => einheit.name === this.curEnergietraeger) || {}).tid || null;
    }

    private setData(): void {
        let sub: number = 0;

        this.dataSheet.forEach((row: Array<string>, index: number) => {
            this.curRowIndex = index;
            const titel: string = this.getTitel() || null;

            if (this.isHeaderRow(row)) {
                this.initData(IDs.ENT_ENERGIEDATEN_WAERME, sub++);
                this.setJahre();
                this.curEnergietraeger = titel;
            } else if (index > 0) {
                this.setBemerkung();
            }

            switch (titel) {
                case 'Abrechnungszeitraum':
                    this.setAbrechnungszeitraum();
                    break;
                case 'Art der Biomasse':
                    this.setValue('energietraeger_tid');
                    break;
                case 'Energieträger':
                    // no break
                case 'Energieträger:':
                    this.setEnergietraeger();
                    break;
                case 'CO2-Emissionen Fernwärme':
                    // no break
                case 'Relevanter CO2-Emissionswert':
                    this.setValue('co2_emissionen', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].co2_emissionen = +value.toFixed(2);
                        }
                    });
                    break;
                case 'Mess-System (Kalibrierung)':
                    this.setValue('messsystem');
                    break;
            }
        });
        this.setDataIgnored();
    }

    private setDataIgnored(): void {
        const entity: string = IDs.ENT_ENERGIEDATEN_WAERME;
        const data: any = this.getDataValided(this.data[entity] || []);
        this.dataIgnored[entity] = [];

        data.forEach((row: any, index: number) => {
            const jahr: number = row.jahr || null;

            if (this.dataDb[entity].some((row: any) => row.jahr === jahr)) {
                this.dataIgnored[entity].push(data[index]);
            }
        });
    }

    protected setEnergietraeger(): void {
        this.setValue('verbrauch', (value: any, index: number) => {
            if (typeof value === 'number') {
                this.data[this.curEntity][index].verbrauch = +value.toFixed(2);
            }

            if (this.curEnergietraeger.indexOf('Sonstiger Energieträger') === 0) {
                this.curEnergietraeger = 'Sonstige Wärmeträger';
            } else if (this.curEnergietraeger === 'Biomasse') {
                const biomasse: string = (this.data[this.curEntity][index].energietraeger_tid || '')
                    .replace('Holzpellets', 'Pellets');
                this.curEnergietraeger = [this.curEnergietraeger , biomasse].join(' - ');
            }
            this.data[this.curEntity][index].energietraeger_tid = this.getEnergietraegerTid();
            this.data[this.curEntity][index].einheit_tid = this.getEinheitTid();
        });
        ++this.curRowIndex;
        this.setValue('kosten');
    }
}
